import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog';
import { Button } from './button';
import { AlertTriangle, CheckCircle, XCircle, Info } from 'lucide-react';
import { ModalData } from '../../hooks/useModal';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  modalData: ModalData;
  onConfirm?: () => void;
  isConfirmModal?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  modalData,
  onConfirm,
  isConfirmModal = false
}) => {
  const getModalIcon = () => {
    switch (modalData.type) {
      case 'error':
        return <XCircle className="h-6 w-6 text-red-500" />;
      case 'warning':
        return <AlertTriangle className="h-6 w-6 text-yellow-500" />;
      case 'success':
        return <CheckCircle className="h-6 w-6 text-green-500" />;
      case 'info':
        return <Info className="h-6 w-6 text-blue-500" />;
      default:
        return <Info className="h-6 w-6 text-blue-500" />;
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-3">
            {getModalIcon()}
            <DialogTitle>{modalData.title}</DialogTitle>
          </div>
          <DialogDescription>{modalData.description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {isConfirmModal ? (
            <>
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                {modalData.cancelText}
              </Button>
              <Button onClick={onConfirm}>
                {modalData.confirmText}
              </Button>
            </>
          ) : (
            <Button onClick={() => onOpenChange(false)}>
              {modalData.confirmText}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;